enum Url {
  ChatWeb3FeedbackForm = "https://alchemyapi.typeform.com/to/fiwDYr6S",
  CustomRpcGuide = "https://www.alchemy.com/blog/supercharge-metamask",
  DiscordSupport = "https://discord.gg/alchemyplatform", // Discord invite behavior decision here https://alchemyinsights.slack.com/archives/C03JX8DJP40/p1704998235494829?thread_ts=1704991742.866929&cid=C03JX8DJP40
  GetAmplified = "https://alchemyapi.typeform.com/to/Yhl13CyU",
  Spearmint = "https://spearmint.xyz/",
  University = "https://alchemy.com/university",
  UniversitySolidityCourse = "https://www.alchemy.com/university/courses/solidity",
  YouTubeChannel = "https://www.youtube.com/c/alchemyplatform",
  AlchemyPricing = "https://www.alchemy.com/pricing",
  Satsuma = "https://alchemy.com/subgraphs-signup",
  AccountKit = "https://accountkit.alchemy.com",
  Home = "https://alchemy.com",
  ContactSales = "https://www.alchemy.com/contact-sales",
  Terms = "https://www.alchemy.com/policies/terms",
  AccountsSupplementTerms = "https://www.alchemy.com/terms-conditions/supplemental-terms",
  AccountsUserTerms = "https://www.alchemy.com/terms-conditions/end-user-terms",
  ModularAccount = "https://accountkit.alchemy.com/smart-accounts/modular-account/getting-started.html",
  EmbeddedAccounts = "https://accountkit.alchemy.com/getting-started/setup.html",
  AlchemySigner = "https://accountkit.alchemy.com/signers/alchemy-signer/introduction.html",
}

enum AlchemyDocsUrl {
  AccountAbstractionSDK = "https://docs.alchemy.com/reference/account-abstraction-sdk",
  AlchemySDK = "https://docs.alchemy.com/reference/alchemy-sdk-quickstart",
  ArchiveData = "https://docs.alchemy.com/docs/what-is-archive-data-on-ethereum",
  BaseApi = "https://docs.alchemy.com/reference/base-api-quickstart",
  BundlerApi = "https://docs.alchemy.com/reference/bundler-api-quickstart",
  ChainApi = "https://docs.alchemy.com/reference/chain-apis-overview",
  ChatWeb3 = "https://docs.alchemy.com/docs/chatweb3#introduction",
  CreateWeb3Dapp = "https://docs.alchemy.com/docs/create-web3-dapp-quickstart",
  ComputeUnits = "https://docs.alchemy.com/reference/compute-units",
  CUCosts = "https://docs.alchemy.com/reference/compute-unit-costs",
  DataPlatform = "https://docs.alchemy.com/reference/data-platform-quickstart",
  DebugApi = "https://docs.alchemy.com/reference/debug-api-quickstart",
  ErrorReference = "https://docs.alchemy.com/reference/error-reference",
  ErrorCodes = `${AlchemyDocsUrl.ErrorReference}#standard-json-rpc-errors`,
  FeatureSupport = "https://docs.alchemy.com/reference/feature-support-by-chain",
  GasManagerAdminApi = "https://docs.alchemy.com/reference/gas-manager-admin-api-quickstart",
  GasManagerCoverageApi = "https://docs.alchemy.com/reference/gas-manager-coverage-api-quickstart",
  GasOptimizedTransactions = "https://docs.alchemy.com/reference/gas-optimized-transactions",
  Home = "https://docs.alchemy.com/",
  NftApi = "https://docs.alchemy.com/reference/nft-api-quickstart",
  PolygonZkEVMQuickstart = "https://docs.alchemy.com/reference/polygon-zkevm-api-quickstart",
  PrivateTransactions = "https://docs.alchemy.com/reference/private-transactions",
  ReinforcedTransactions = "https://docs.alchemy.com/reference/reinforced-transactions",
  SmartWebSockets = "https://docs.alchemy.com/reference/sdk-websockets-endpoints",
  SubscriptionApi = "https://docs.alchemy.com/reference/subscription-api",
  Throughput = "https://docs.alchemy.com/reference/throughput",
  TokenApi = "https://docs.alchemy.com/reference/token-api-quickstart",
  TraceApi = "https://docs.alchemy.com/reference/trace-api-quickstart",
  TransactionHistoryApi = "https://docs.alchemy.com/reference/transfers-api-quickstart",
  TransactionReceiptsApi = "https://docs.alchemy.com/reference/alchemy-gettransactionreceipts",
  TransactionSimulationApi = "https://docs.alchemy.com/reference/simulation",
  WebhooksApi = "https://docs.alchemy.com/reference/notify-api-quickstart",
  PricingAutoscale = "https://docs.alchemy.com/reference/pricing-plans#auto-scale-compute-growth--scale-tier-only",
  Alerts = "https://docs.alchemy.com/docs/dashboard-alerts",
  LogEvents = "https://docs.alchemy.com/docs/how-to-get-on-chain-events",
  EthCall = "https://docs.alchemy.com/reference/eth-call",
}

enum MailTo {
  SubgraphSales = "mailto:subgraph-sales@alchemy.com",
}

// Removes any urls from sentence, helpful for printing errors and not exposing internal urls externally
// Yes - its chatgpt generated
function stripUrls(sentence: string): string {
  const words = sentence.split(/\s+/); // Split the sentence into words
  function isUrl(word: string): boolean {
    // This regex pattern checks for common URL structures
    const urlRegex = /^(?:(?:https?|ftp):\/\/)?[\w/:%#$&?()~.=+-]+$/i;
    return urlRegex.test(word);
  }
  // Filter out words that look like URLs
  const filteredWords = words.filter((word) => !isUrl(word));
  // Join the filtered words back into a sentence
  return filteredWords.join(" ");
}

export { Url, AlchemyDocsUrl, MailTo, stripUrls };
